import { useState } from "react"
import GestionObrasSociales from "./GestionObrasSociales"
import AltaUsuario from "./AltaUsuario"
import ListaUsuarios from "./ListaUsuarios"

function GestionUsuarios() {
  const [refreshKey, setRefreshKey] = useState(0)
  const refrescar = () => setRefreshKey(k => k + 1)

  return (
    <div className="column adminTabGap">
      <AltaUsuario refreshKey={refreshKey} onUsuarioCreado={refrescar} />
      <div className="adminSeparador" />
      <GestionObrasSociales onCambio={refrescar} />
      <div className="adminSeparador" />
      <ListaUsuarios />
    </div>
  )
}

export default GestionUsuarios
